import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";

@Component({
    selector: 'app-new-application-version-popup',
    templateUrl: './new-application-version-popup.component.html',
    styleUrls: ['./new-application-version-popup.component.scss'],
    standalone: false
})

export class NewApplicationVersionPopupComponent {

  public subject: Subject<void>;

  constructor(private bsModalRef: BsModalRef) {}

  public confirm(): void {
    this.bsModalRef.hide();
    this.subject.next();
    this.subject.complete();
  }

}